import { gql } from "@apollo/client";

export const UPDATE_GESTION_PRESUPUESTO = gql`
mutation UpdateGestionPresupuesto($input: UpdateGestionPresupuestoInput!) {
    updateGestionPresupuesto(input: $input){
        idEvaluacion
    }
}
`;